import { IinfractionTicket } from "@/types/infractionTickets.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getInfractionTickets({
  status = [],
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = "",
  orderBy = "-createdAt",
  fields = "createdAt,infractionDate,dueDate,licensePlate,trafficTicket,value, status ",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );

  const url = `${API_URL}/infractions?${params.toString()}`;

  const result = (await makeRequestDebounced(url)) as ApiResponseType<IinfractionTicket[]> & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function createInfractionTicketWithFile(
  data: Partial<IinfractionTicket>,
  file: File
) {
  const url = `${API_URL}/infractions/upload`;
  const formData = new FormData();

  formData.append("licensePlate", data.licensePlate!);
  formData.append("trafficTicket", data.trafficTicket!);
  formData.append("value", data.value!.toString());
  formData.append(
    "infractionDate",
    (data.infractionDate as Date).toISOString()
  );
  formData.append("status", data.status!);
  formData.append("dueDate", (data.dueDate as Date).toISOString());
  formData.append("documentNumber", data.documentNumber!);
  formData.append("document", file);

  const options = {
    method: "POST",
    body: formData,
  };

  return makeRequest<IinfractionTicket>(url, options);
}
